<div>
  <div #googleMapEl class="google-map-container"></div>
</div>
